import getChangeFormatOptions from '@/organisms/charts/utils/getChangeFormatOptions';
import format from '@pkg/utils/numbers/format';

export default function formatDifference(
  difference,
  { metric, absolute } = {}
) {
  const options = getChangeFormatOptions(metric, absolute);

  switch (true) {
    case difference === null:
      return null;
    case difference > 0:
      return '▲' + format(difference, options);
    case difference < 0:
      return '▼' + format(difference, options);
    default:
      return format(0, options);
  }
}
